module.exports = __webpack_public_path__ + "img/lesson.7d34d20e.webp";